const openEmployeeModals = document.querySelectorAll('.open-employee-modal');

openEmployeeModals.forEach((openEmployeeModal) => {
  openEmployeeModal.addEventListener('click', () => {
    const parent = openEmployeeModal.closest('.employee-module__table-row');
    const modal = parent.querySelector('.employee-module__modal-wrapper');
    const closeModal = modal.querySelector('.employee-module__modal__close');

    modal.classList.add('is-active');

    closeModal.addEventListener('click', () => {
      modal.classList.remove('is-active');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        modal.classList.remove('is-active');
      }
    });
  });
});
